import React from 'react';
import classnames from 'classnames';

import { Icon, Text } from '~/ui';

import './ClientSelectorItem.scss';

interface ClientSelectorItemProps {
    name: string;
    id: string;
    isSelected?: boolean;
    onClick: (id: string) => void;
}

const ClientSelectorItem = ({
    name,
    id,
    onClick,
    isSelected = false
}: ClientSelectorItemProps): JSX.Element => {
    const rootClass = 'client-selector-item';
    const buttonClassNames = classnames(`${rootClass}`, '_d-flex');

    return (
        <button
            data-testid="client-selector-item"
            type="button"
            className={buttonClassNames}
            onClick={() => onClick(id)}
        >
            <Text variant="16-medium" className={`${rootClass}__name`}>
                {name}
            </Text>
            <Icon
                icon={isSelected ? 'radioChecked' : 'radioUnchecked'}
                size="l"
                color="neptune-400"
                className={`${rootClass}__icon`}
                data-testid={
                    isSelected
                        ? 'selected-client-item'
                        : 'unselected-client-item'
                }
            />
        </button>
    );
};

export { ClientSelectorItem };
